import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, validations } from "../../common/validation.common";

export namespace RadiusNASValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            secret: baseVals.string(),
            address: baseVals.ipv4(),
            port: v.optional(baseVals.intRange(1, 65535, "Port")),
            username: v.optional(baseVals.string()),
            password: v.optional(baseVals.string()),
            snmpPort: v.optional(baseVals.intRange(1, 65535, "SNMP Port")),
            snmpCommunity: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            secret: v.exactOptional(baseVals.string()),
            address: v.exactOptional(baseVals.ipv4()),
            port: v.exactOptional(baseVals.intRange(1, 65535, "Port")),
            username: v.exactOptional(baseVals.string()),
            password: v.exactOptional(baseVals.string()),
            snmpPort: v.exactOptional(baseVals.intRange(1, 65535, "SNMP Port")),
            snmpCommunity: v.exactOptional(baseVals.string()),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            username: validations.deletable,
            password: validations.deletable,
        }),
    );
}
